import {Component, Input} from "@angular/core";
import {AvdbPricingProduct} from "../database-pricing/avdb-pricing-product";
import {AvdbPricingProductSeries} from "../database-pricing/avdb-pricing-product-series";
import {Message} from "./message";
import {cdnURL} from "site";

@Component({
	selector: "product-series-display",
	template: `
		<div *ngFor="let productSeries of product.series" [ngClass]="{
			'databasepricing_row_group': true,
			'databasepricing_row_group-padded': product.series.length > 1
		}">
			<label *ngIf="label; else coverageImage" [for]="label">
				<ng-container [ngTemplateOutlet]="coverageImage"></ng-container>
			</label>
			<ng-template #coverageImage>
				<image-container
					[width]="100"
					[height]="80"
					[src]="COVERAGE_MAP_PATH + productSeries.region.coverageMapFilename"
					[alt]="'Coverage Map'"
					(click)="coverageModal.open(productSeries.region, productSeries.coverageDurationOptions, product)">
				</image-container>
			</ng-template>
			<div class="databasepricing_row_info">
				<label *ngIf="label; else databaseName" [for]="label">
					<ng-container [ngTemplateOutlet]="databaseName"></ng-container>
				</label>
				<ng-template #databaseName>
					<h4>
						{{productSeries.region.name}}
						<span *ngIf="productSeries.region.vendorName">
							by {{productSeries.region.vendorName}}
						</span>
					</h4>
				</ng-template>
				<p class="databasepricing_coverage_link">
					<a (click)="coverageModal.open(productSeries.region, productSeries.coverageDurationOptions, product)">
						View Coverage Details
					</a>
				</p>
				<ng-container *ngIf="!!productSeries.customerComments">
					<avdb-message [message]="infoMessageFromComment(productSeries.customerComments)"></avdb-message>
				</ng-container>
			</div>
		</div>

		<coverage-detail #coverageModal [coverageMapPath]="COVERAGE_MAP_PATH"></coverage-detail>
	`,
})

export class ProductSeriesDisplayComponent {
	@Input() product: AvdbPricingProduct;
	@Input() label: string;
	@Input() additionalMessages = new Map<number, Array<Message>>();

	readonly COVERAGE_MAP_PATH = cdnURL + "/img/avdb_type_regions/";

	messages(series: AvdbPricingProductSeries) {
		let additionalMessages = this.additionalMessages.get(series.id) || [];
		return [...additionalMessages, ...series.messages];
	}

	infoMessageFromComment(text: string) {
		return Message.info(text);
	}
}
